import React from 'react';

// Colores de la bandera de México (verde más vivo para que resalte sobre el fondo)
const VERDE = '#0a8f4c';
const BLANCO = '#ffffff';
const ROJO = '#ce1126';
const COLORS = [VERDE, BLANCO, ROJO];
const HOYO = '#05603c'; // color del fondo (los hoyitos se ven como recorte)

// --- Geometría del "swag" (guía que cuelga en curva) ---
const W = 216;      // ancho de cada arco (se repite)
const N = 9;        // banderitas por arco (muchas)
const TOP = 5;      // altura de los extremos del hilo
const SAG = 26;     // cuánto baja el centro (la curva)
const CY = TOP + 2 * SAG; // punto de control de la curva
const FW = 16;      // ancho de banderita
const BODY = 20;    // alto del cuerpo
const FRINGE = 6;   // profundidad de los picos
const H = 72;       // alto total del SVG

// y sobre el arco (curva de bézier cuadrática) para un t dado
const arcY = (t: number) =>
  TOP * ((1 - t) ** 2 + t ** 2) + 2 * (1 - t) * t * CY;

// Una banderita colgando desde (fx, fy) con orilla de picos + hoyitos
const Bandera: React.FC<{ fx: number; fy: number; color: string }> = ({ fx, fy, color }) => (
  <g>
    <path
      d={
        `M${fx},${fy} L${fx + FW},${fy} L${fx + FW},${fy + BODY} ` +
        `L${fx + FW - 2.67},${fy + BODY + FRINGE} L${fx + FW - 5.33},${fy + BODY} ` +
        `L${fx + FW - 8},${fy + BODY + FRINGE} L${fx + FW - 10.67},${fy + BODY} ` +
        `L${fx + FW - 13.33},${fy + BODY + FRINGE} L${fx},${fy + BODY} Z`
      }
      fill={color}
      stroke="rgba(0,0,0,0.22)"
      strokeWidth={0.7}
    />
    <circle cx={fx + FW / 2} cy={fy + 7} r={2} fill={HOYO} />
    <circle cx={fx + FW / 2} cy={fy + 13} r={1.5} fill={HOYO} />
  </g>
);

// Un arco con sus banderitas (se usa dentro del <pattern>)
const Swag: React.FC = () => {
  const banderas = Array.from({ length: N }, (_, i) => {
    const t = (i + 0.5) / N;
    const xc = t * W;
    return { fx: xc - FW / 2, fy: arcY(t), color: COLORS[i % 3] };
  });
  return (
    <g>
      {/* hilo que cuelga en curva */}
      <path d={`M0,${TOP} Q${W / 2},${CY} ${W},${TOP}`} stroke="#7a4a1e" strokeWidth="1.5" fill="none" />
      {banderas.map((b, i) => (
        <Bandera key={i} fx={b.fx} fy={b.fy} color={b.color} />
      ))}
    </g>
  );
};

const PapelPicado: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    width="100%"
    height={H}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ display: 'block', filter: 'drop-shadow(0 3px 2px rgba(0,0,0,0.28))' }}
    aria-hidden="true"
  >
    <defs>
      <pattern id="papel-picado" width={W} height={H} patternUnits="userSpaceOnUse">
        <Swag />
      </pattern>
    </defs>
    <rect width="100%" height={H} fill="url(#papel-picado)" />
  </svg>
);

// Banderita de México en SVG (se ve igual en Windows, móvil, etc. — el emoji 🇲🇽 no)
export const BanderaMX: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    viewBox="0 0 30 20"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Bandera de México"
    style={{ display: 'inline-block', height: '0.85em', width: 'auto', verticalAlign: '-0.06em', borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.35)' }}
  >
    <rect x="0" width="10" height="20" fill="#006847" />
    <rect x="10" width="10" height="20" fill="#ffffff" />
    <rect x="20" width="10" height="20" fill="#ce1126" />
    <circle cx="15" cy="10" r="2.6" fill="#9a6b2f" />
  </svg>
);

export default PapelPicado;
